export default function SignOutIcon({className = ''}: {className?: string}) {
    return (
        <svg className={className} height="1.25em" width="1.25em" fill="currentColor" viewBox="0 -960 960 960" >
            <path d="M160-160v-640h320.77v40H200v560h280.77v40H160Zm498.46-178.46-28.08-28.77L723.15-460H367.69v-40h355.46l-92.77-92.77 28.08-28.77L800-480 658.46-338.46Z"/>
        </svg>
    )
}